import React from "react";
import { Box } from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";

// Reusable search bar — three attached segments in one row: the app logo,
// the text input, then the search icon. Fully controlled (value/onChange),
// so the parent page drives its own live filtering off `value` exactly the
// same way a plain TextField would.
// `startContent` (optional): anything shown inside the bar before the text — a back button and the chips of what is already chosen.
const SearchBar = ({ value, onChange, placeholder = "Search Bar", logo = "/assests/website-logo.png", sx, inputProps, startContent }) => (
    <Box
        // Stable hook so a page can re-theme it via a CSS cascade (Settings gold theme).
        className="ms-search-bar"
        sx={{
            display: "flex", alignItems: "stretch",
            border: "1.5px solid #4B5563", borderRadius: "10px",
            overflow: "hidden", bgcolor: "#ffffff",
            ...sx,
        }}
    >
        <Box sx={{
            display: "flex", alignItems: "center", justifyContent: "center",
            px: 1.4, borderRight: "1.5px solid #4B5563", bgcolor: "#ffffff", flexShrink: 0,
        }}>
            <Box component="img" src={logo} alt="" sx={{ width: 20, height: 20, objectFit: "contain" }} />
        </Box>

        {startContent ? (
            <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 0.6, py: 0.6, pl: 1, maxWidth: "72%", flexShrink: 0 }}>{startContent}</Box>
        ) : null}

        <Box
            component="input"
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            {...inputProps}
            sx={{
                flex: 1, minWidth: 0, border: "none", outline: "none",
                padding: "9px 12px", fontSize: 14, fontFamily: "inherit",
                color: "#000000", bgcolor: "transparent",
                "&::placeholder": { color: "#000000", opacity: 0.65 },
            }}
        />

        <Box sx={{
            display: "flex", alignItems: "center", justifyContent: "center",
            px: 1.6, borderLeft: "1.5px solid #4B5563", bgcolor: "#ffffff", flexShrink: 0,
        }}>
            <SearchIcon sx={{ fontSize: 19, color: "#4B5563" }} />
        </Box>
    </Box>
);

export default SearchBar;
